import { render, staticRenderFns } from "./OtherShare.vue?vue&type=template&id=1fd505ef&scoped=true"
import script from "./OtherShare.vue?vue&type=script&lang=js"
export * from "./OtherShare.vue?vue&type=script&lang=js"
import style0 from "./OtherShare.vue?vue&type=style&index=0&id=1fd505ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd505ef",
  null
  
)

export default component.exports